var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',{attrs:{"breadcrumbs":_vm.breadcrumbs}},[_c('div',{staticClass:"connect-learn-page"},[_c('div',{staticClass:"container"},[_c('connect-how-it-works',{attrs:{"type":"project"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }